import React from 'react';
import { Box, InfoOutlineIcon, Inscription, OptionKey } from '@common-fe/common-fe';

import { Dependent } from '@/modules/employee/employee.types';

import { DeductibleUser } from './hooks/useDependents';
import SpendTrackerUsersList from './SpendTrackerUsersList';

interface Props {
  employeeUser: DeductibleUser;
  coverageLevelLabel?: string;
  users: Dependent[];
  selectedHealthPlanYearId?: OptionKey;
  individualTotal?: number;
}

const EmbeddedOnlySpendTracker: React.FC<Props> = ({
  employeeUser,
  coverageLevelLabel,
  users,
  selectedHealthPlanYearId,
  individualTotal,
}) => {
  return (
    <Box
      direction="column"
      elevation="default"
      round="container1Round"
      fill
      background="canvas"
      style={{ height: 'auto' }}
      pad="spacing24"
      margin={{ top: 'spacing24' }}
    >
      <Inscription weight="bold" margin={{ bottom: 'spacing10' }}>
        {`Coverage level: ${coverageLevelLabel || ''}`}
      </Inscription>
      <Box
        data-testId="embedded-only-info-banner"
        direction="row"
        align="center"
        gap="spacing8"
        background="infoContainer"
        border={{ color: 'infoBorder' }}
        round="container2Round"
        pad={{ horizontal: 'spacing16', vertical: 'spacing8' }}
        width={{ max: 'fit-content' }}
      >
        <InfoOutlineIcon color="info" size="24px" />
        <Inscription>
          Family deductibles aren't supported by your plan. Select a family member to check their individual
          deductibles
        </Inscription>
      </Box>
      <SpendTrackerUsersList
        employeeUser={employeeUser}
        users={users}
        disabled={!individualTotal}
        selectedHealthPlanYearId={selectedHealthPlanYearId}
      />
    </Box>
  );
};

export default React.memo(EmbeddedOnlySpendTracker);
